import { createFileRoute } from "@tanstack/react-router";
import { catalogDraftDogRoute } from "@/app-clients/catalog-detail/dog-route-data";
import { DraftRouteComponent } from "@/app-clients/catalog-detail/dog-route";
import { DogRouteNotFound } from "@/app-clients/catalog-detail/dog-route-not-found";

export const Route = createFileRoute("/dog/$dogId_/draft")({
    beforeLoad: catalogDraftDogRoute.beforeLoad,
    staleTime: catalogDraftDogRoute.staleTime,
    loader: catalogDraftDogRoute.loader,
    head: catalogDraftDogRoute.head,
    component: DraftRouteComponent,
    notFoundComponent: DogRouteNotFound,
});
